import { SERVICE_URL } from './ServiceURL'

class PaymentService {
  constructor(resource) {
    this.store = resource.$store
    this.http = resource.$http
  }

  hasCentercob(cep) {
    if(!cep) return Promise.reject()
    return this.http.get(`${SERVICE_URL}v1/centercob/faixa/${cep}`, {
        headers: {
          'x-access-token': this.store.state.user.token || ''
        }
      })
      .then(response => response.json())
      .catch(err => {
        reject(err.body.message || err.message)
      })
  }

  getMethods() {
    return new Promise((resolve, reject) => {
      this.http.get(`${SERVICE_URL}v1/formasPagamento`, {
          headers: {
            'x-access-token': this.store.state.user.token || ''
          }
        })
        .then(response => response.json())
        .then(methods => resolve(methods))
        .catch(err => {
          reject(err.body.message || err.message)
        })
    })
  }

  getPlans() {
    return new Promise((resolve, reject) => {
      this.http.get(`${SERVICE_URL}v1/formasPagamento/planos`, {
          headers: {
            'x-access-token': this.store.state.user.token || ''
          }
        })
        .then(response => response.json())
        .then(methods => resolve(methods))
        .catch(err => {
          reject(err.body.message || err.message)
        })
    })
  }

  getPayDays(gv) {
    return new Promise((resolve, reject) => {
      this.http.get(`${SERVICE_URL}v1/formasPagamento/vencimentos/${gv}`, {
          headers: {
            'x-access-token': this.store.state.user.token || ''
          }
        })
        .then(response => response.json())
        .then(paydays => resolve(paydays))
        .catch(err => {
          reject(err.body.message || err.message)
        })
    })
  }
}

export default PaymentService



// WEBPACK FOOTER //
// ./src/service/PaymentService.js